module.exports = __webpack_public_path__ + "static/media/ic_callBtn.9480b6ef.svg";